module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_3_1-7d08fa7e08f56eb91b7a87bc37183cb8.webp";